import cookie from 'js-cookie';
import React from 'react';

export function isNonProduction() {
  return (
    process.env.ENV === 'stage' || process.env.ENV === 'development' || process.env.ENV === 'local'
  );
}

const CookieDebug: React.FC = () => {
  return (
    <>
      <button onClick={() => cookie.set('my-test', '???')}>set cookie</button>
      <button onClick={() => localStorage.setItem('my-test', '!!!')}>set local storage</button>
      <button onClick={() => console.info(cookie.get('my-test'))}>get cookie</button>
      <button onClick={() => console.info(localStorage.getItem('my-test'))}>
        get local storage
      </button>
    </>
  );
};

const Debug: React.FC = () => {
  return <CookieDebug />;
};

export const DebugProxy: React.FC = () => {
  const [enabled] = React.useState<boolean>(() => {
    if (
      process.env.ENV === 'stage' ||
      process.env.ENV === 'development' ||
      process.env.ENV === 'local'
    ) {
      try {
        return !!localStorage.getItem('enable_debug_mode');
      } catch (e) {
        console.error('Local storage error');
      }
    }

    return false;
  });

  if (enabled) {
    return <Debug />;
  }

  return null;
};
